module.exports = __webpack_public_path__ + "static/media/burst-nappy-.0397be67.png";